import OperatorEditor from './OperatorEditor';

export default OperatorEditor;
